<script setup>
defineProps({
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value),
  },
})
</script>

<template>
  <div class="spinner" :class="`spinner-${size}`">
    <div class="spinner-circle"></div>
  </div>
</template>

<style scoped>
.spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.spinner-circle {
  border-radius: 50%;
  border-style: solid;
  border-color: var(--color-primary);
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
}

.spinner-sm .spinner-circle {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

.spinner-md .spinner-circle {
  width: 32px;
  height: 32px;
  border-width: 3px;
}

.spinner-lg .spinner-circle {
  width: 48px;
  height: 48px;
  border-width: 4px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
